export const seoConsts = {
  title: 'Рассчитать стоимость доставки по городу - Яндекс Доставка',
  description:
    'Рассчитайте стоимость доставки по городу сервисом Яндекс Доставка – быстрый и удобный расчет доставки ваших заказов.',
}
